// extracted by mini-css-extract-plugin
export default {"container":"CardImage_container__ehaIA","title":"CardImage_title__SqfqI","effect":"CardImage_effect__YGefs","image":"CardImage_image__Da-36"};